var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6038 7.745L24.4064 8.73862C24.9697 8.8183 25.4431 9.212 25.623 9.75099C25.8029 10.2947 25.6561 10.8852 25.249 11.2883L20.3163 16.0783L21.4808 22.9493C21.5755 23.5118 21.3435 24.0836 20.8701 24.4163C20.4015 24.7491 19.7813 24.7913 19.2748 24.5241L13.1965 21.3136L7.12288 24.5241C6.61162 24.7913 5.99148 24.7491 5.52282 24.4163C5.05416 24.0836 4.81747 23.5118 4.91688 22.9493L6.08142 16.0783L1.14774 11.2883C0.740154 10.8852 0.595297 10.2947 0.774239 9.75099C0.952707 9.212 1.42468 8.8183 1.99227 8.73862L8.78922 7.745L11.8379 1.5428C12.0887 1.02649 12.6189 0.69873 13.1965 0.69873C13.7788 0.69873 14.309 1.02649 14.5598 1.5428L17.6038 7.745Z",
    fill: "black",
    fillOpacity: 0.44
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDark);
export default __webpack_public_path__ + "static/media/star_dark.09fbfff27551017c2ca4db2f81ace9c5.svg";
export { ForwardRef as ReactComponent };